export default "__VITE_ASSET__D4WRSXu5__"